import { z } from "zod";
import {
  PROPERTY_ID,
  OCP_ID,
  STATUS,
  FEES,
  RECEIPTS,
 } from "../../consts";

export const schema = z.object({
  [OCP_ID]: z.string().min(1, "This field is required"),
  [PROPERTY_ID]: z.string().min(1, "This field is required"),
  [FEES]: z.any().optional(),
  [RECEIPTS]: z.any().optional(),
  // [CLOSING_FEE]: z.any().optional(),
  // [CLOSING_FEE_AMT]: z.string().optional(),
  // [RUSH_FEE]: z.any().optional(),
  // [MOVE_IN_FEE]: z.any().optional(),
  // [CAPITAL_CONTRIBUTION]: z.any().optional(),
  [STATUS]: z.string().optional(),
});


export type formValues = z.infer<typeof schema>;
